<style lang="scss" scoped>
@import '$vars';

.importer {
  border: 2px solid #e1e1e1;
  padding: 20px;
  margin-bottom: 20px;
  form {
    padding: 40px 0;
    h4 {
      margin-bottom: 20px
    }
  }
  >header {
    padding-bottom: 20px;
    ul {
      display: flex;
      justify-content: center;
      li {
        cursor: pointer;
        margin: 0 3px;
        align-items: center;
        i {
          display: inline-block;
          width: 1.5em;
          height: 1.5em;
          text-align: center;
          line-height: 1.2em;
          border-width: 1px;
          border-style: solid;
          border-color: #e1e1e1;
          border-radius: 50%;
          font-style: normal
        }
        b {
          border-top: 1px solid darken(#e1e1e1, 6%);
          height: 1px;
          width: 160px;
          display: inline-block;
          margin-bottom: 5px;
          margin-right: 10px;
          margin-left: 10px;
        }
        &.selected {
          i {
            color: white;
            background: $color-blue
          }
        }
      }
    }
  }
  >div {
    >p {
      display: flex;
      flex-direction: column;
    }
    .step_icon {
      width: 60px;
      margin: 20px auto;
    }
    label {
      text-transform: none
    }
    input {
      display: none
    }
  }
}

.escolherArquivo {
  align-items: center;
  display: inline-flex;
  justify-content: center;
}

.lista {
  &__steps {
    padding: 1rem 0;
    display: flex;
    width: 100%;

    &-item {

      i {
        align-items: center;
        border-radius: 50%;
        display: flex;
        justify-content: center;

        span {
          font-size: 0.7rem;
          font-weight: 500;
        }
      }

      &.selected {
        i {
          border-color: transparent;
        }
      }
    }
  }
}

.centered-message {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>

<template>
  <main>
    <p v-if="step > -1">Envie a sua planilha para importar os seus dados</p>
    <div class="importer d-flex flex-space_around" v-if="step === -1">
      <form @submit.prevent="$emit('origin', {sourceSystem: formData.sourceSystem.value, sourceSystemCnpj: formData.sourceSystemCnpj.value }); step = 0" class="columns col-8">
        <h4 class="col-12 text-center">Primeiramente, informe o nome e o CNPJ de origem</h4>
        <dr-field
          v-for="(field, name) in formData"
          :form.sync="formData"
          :validators.sync="$v.formData[name]"
          :field.sync="field"
          :id="name"
          :ref="name"
          :key="'main_'+name">
        </dr-field>

        <div class="centered-message">
          <small>
            As informações acima não são de preenchimento obrigatório.
          </small>
        </div>

        <div class="centered-message">
          <drSubmit :disabled="$v.formData.$invalid" style="margin: 20px auto" size="sm" text="Próximo" />
        </div>
      </form>
    </div>
    <section class="importer" v-else>
      <header>
        <ul class="list-unstyled lista__steps">
          <li
            v-for="(section, $index) of steps"
            :key="'step'+$index"
            :class="$index === step ? 'selected lista__steps-item' : 'lista__steps-item'"
            @click="step = $index">
            <b v-if="$index === 2"></b>
            <i><span>{{$index + 1}}</span></i>
            <span>{{section.title}}</span>
            <b v-if="$index === 0"></b>
          </li>
        </ul>
      </header>
      <transition name="fade" mode="out-in">
        <div class="text-center" :key="step">
          <big><strong>{{steps[step].description}}</strong></big>
          <p>
            <dr-icon class="step_icon"  :fill="'blue'" :name="steps[step].icon"></dr-icon>
            <small>Escolha a partir de um arquivo Excel .csv</small>
          </p>
          <label :disabled="sending" for="file" class="btn btn-sm btn-primary escolherArquivo">
            Escolher Arquivo
            <input :disabled="sending" id="file" type="file" @change="checkfile($event)" />
          </label>
        </div>
      </transition>
    </section>
    <p v-if="step > -1" class="text-center">Caso você não possua nenhuma planilha, baixe o nosso modelo para preencher com os seus dados</p>
    <p v-if="step > -1" class="text-center"><strong><a :href="`/static/modeloImportacaoDrConecta.zip`">Baixar planilha Dr.Conecta</a></strong></p>
  </main>
</template>

<script>
import { formData, validations } from '@/data/formData/importPreview'
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'

export default {
  props: ['selectedOffice', 'origin'],
  components: {
    drField,
    drSubmit
  },
  data () {
    return {
      step: -1,
      formData,
      steps: [
        {
          title: 'Pacientes',
          type: 'special_patient',
          icon: 'user',
          description: 'Primeiro, importe a lista de seus pacientes',
          endpoint: `/doctor/doctor_office/${this.selectedOffice.id}/special_patient/import`
        },
        {
          title: 'Agenda',
          type: 'agenda',
          icon: 'agenda',
          description: 'Agora, importe os dados da sua agenda',
          endpoint: `/doctor/doctor_office/${this.selectedOffice.id}/special_patient/import`
        },
        {
          title: 'Financeiro',
          type: 'financial_statement',
          icon: 'money',
          description: 'Se quiser, importe os seus dados financeiros (opcional)',
          endpoint: `/doctor/doctor_office/${this.selectedOffice.id}/special_patient/import`
        }
      ],
      file: null,
      sending: false
    }
  },
  validations: {
    formData: validations
  },
  mounted () {
    for (let field in this.formData) {
      this.formData[field].value = null
    }
  },
  methods: {
    checkfile (file) {
      if (file.target.files[0].type === 'application/vnd.ms-excel' || file.target.files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.file = file.target.files[0]
        this.upload()
        return
      }
      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: 'O arquivo não é uma planilha',
        size: 'md',
        active: true
      })
    },
    upload () {
      this.sending = true
      this.fn_SHOW_PROGRESS()
      let formData = new FormData()
      formData.append('import[file][file]', this.file)
      formData.append('import[sourceSystem]', this.origin.sourceSystem)
      formData.append('import[sourceSystemCnpj]', this.fn_NUMBERS_ONLY(this.origin.sourceSystemCnpj))
      let data = formData
      let headers = this.fn_COPY_OBJECT(this.$store.getters.getAuthHeader)
      let boundary = Math.random().toString().substr(2)
      headers.headers['Content-Type'] = `multipart/form-data; charset=utf-8; boundary=${boundary}`
      this.$http.post(`/doctor/doctor_office/${this.selectedOffice.id}/${this.steps[this.step].type}/import`, data, headers).then(
        (res) => {
          this.$emit('uploaded', res.data)
          this.$router.push(`/doctor/patients/import/${this.steps[this.step].type}/identify/`)
        }
      ).catch(
        (err) => {
          console.log(err)
        }
      ).finally(
        () => {
          this.sending = false
          this.fn_HIDE_PROGRESS()
        }
      )
    }
  }
}
</script>
